import React, { useState, useEffect } from 'react';
import Range from 'rc-slider/lib/Range';
import 'rc-slider/assets/index.css';

export interface PriceFilterProps {
  currencySymbol: string;
  handlePriceFilter: (priceGte: number, priceLte: number, mode: string) => void;
  mode: string;
  priceGte?: number;
  priceLte?: number;
}

const PriceFilter: React.FC<PriceFilterProps> = ({ handlePriceFilter, mode, priceGte, priceLte, currencySymbol }) => {
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(5050);

  useEffect(() => {
    setMinPrice(priceGte);
  }, [priceGte]);

  useEffect(() => {
    setMaxPrice(priceLte || 5050);
  }, [priceLte]);

  const currency = currencySymbol === 'USD' ? '$' : '€';

  return (
    <div data-cy="filters-price" style={{ margin: '20px 0 15px 10px', width: '90%' }}>
      <Range
        allowCross={false}
        count={2}
        dotStyle={{ display: 'none' }}
        handleStyle={[
          {
            backgroundColor: 'white',
            border: 'solid 2px #ebeded',
            boxShadow: '0 0px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.09)',
            height: '18px',
            marginTop: '-7px',
            width: '18px',
          },
          {
            backgroundColor: 'white',
            border: 'solid 2px #ebeded',
            boxShadow: '0 0px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.09)',
            height: '18px',
            marginTop: '-7px',
            width: '18px',
          },
        ]}
        marks={{
          0: { label: `${currency}${minPrice}`, style: { color: 'black', transform: 'translate(-8px, -40px)' } },
          5050: {
            label: `${currency}${!maxPrice || maxPrice === 5050 ? '5000+' : maxPrice}`,
            style: { color: 'black', transform: 'translate(-40px, -40px)' },
          },
        }}
        max={5050}
        min={0}
        onAfterChange={val => handlePriceFilter(val[0], val[1] === 5050 ? null : val[1], mode)}
        onChange={val => {
          setMinPrice(val[0]);
          setMaxPrice(val[1]);
        }}
        pushable={50}
        railStyle={{
          backgroundColor: '#cbd1d0',
          height: '3px',
        }}
        step={50}
        tipFormatter={value => `${currency}${value}`}
        trackStyle={[{ backgroundColor: 'black', height: '3px' }]}
        value={[minPrice, maxPrice]}
      />
    </div>
  );
};

export default PriceFilter;
